import DownloadDesktopModal from './DownloadDesktopModal';

export default DownloadDesktopModal;
